import { useState } from 'react';
import { useSelector } from 'react-redux';
import { keyBy } from 'lodash';
import { TState } from '../../redux/store';
import { Card, Flex, Input, Text } from '@chakra-ui/react';
import { useGetFields } from './Form';

const RepeatGroup = (props: any) => {
  const { handleOnChange, f: input, formData, isDisabled } = props as any;

  const [nbRepeat, setNbRepeat] = useState<number | ''>(
    Number(formData[input.name_id] || input.defaultRepeat || 1),
  );

  const dataInputs = useSelector((state: TState) => state.dataInputs);
  const inputsById = keyBy(dataInputs, 'name_id');

  const handleChange = async (label: string, e: any, forced?: boolean) => {
    handleOnChange(label, e, forced);
  };

  const getFields = useGetFields();

  return (
    <>
      <Input
        isDisabled={isDisabled}
        pl={2}
        h='32px'
        type='number'
        onChange={(e: any) => {
          setNbRepeat(e?.target?.value ? Number(e?.target?.value) : '');
          handleOnChange(input.name_id, e?.target?.value);
        }}
        value={nbRepeat ?? null}
        bgColor={'#ffffff'}
        min={1}
      />
      <Flex gap={3} mt={3} flexWrap='wrap'>
        {Array(nbRepeat)
          .fill('')
          .map((_, idx) => (
            <Card p={2} flex='0 0 calc(50% - 8px)'>
              <Text textTransform='capitalize'>{`${input.label} ${
                idx + 1
              }`}</Text>
              {getFields(
                input.repeatFields
                  ?.map((id: string) =>
                    !inputsById[id]
                      ? null
                      : {
                          ...inputsById[id],
                          name: `repeat_${inputsById[id]?.name_id}_${idx}`,
                          baseName: inputsById[id].name_id,
                        },
                  )
                  .filter((f: any) => f),
                {
                  ...props,
                  handleOnChange: handleChange,
                },
              )}
            </Card>
          ))}
      </Flex>
    </>
  );
};

export default RepeatGroup;
